<button type="button" class="btn btn-primary mt-0" (click)="handleReportClick()">{{ buttonText }}</button>

<app-modal #reportModal [modalConfig]="modalConfig">
  <div class="container">
  <div class="form-row">
    <div class="form-group col-12 col-sm-12 mb-0">
      <textarea
        class="form-control"
        placeholder="Write a reason*"
        [(ngModel)]="reasonOfReporting"
      ></textarea>
    </div>
  </div>
  </div>
</app-modal>
